export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/primary-early-vote-tracker-2018/node_modules/d3-random/src/defaultSource.js
// module id = null
// module chunks = 